import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { Api } from '@/externals/corner-logis/Swagger';

import { MAX_PACKAGE_COUNT } from '../../data';
import { CornerLogis } from '../../helpers';

export const 원스톱_솔루션_입고_쿼리 = createQueryKeys('corner-logis-inbound', {
  입고_가능일_조회: ({ shopID, query }: { shopID: string; query: Api.GetAvailableDate.RequestQuery }) => ({
    queryKey: [shopID, query] as const,
    queryFn: () => {
      return CornerLogis.proxy<Api.GetAvailableDate.ResponseBody>({
        method: 'GET',
        path: '/api/v1/inbound/getDate/available',
        params: query,
        shopID,
      });
    },
  }),

  입고_예정서_목록_조회: ({ shopID, query }: { shopID: string; query: Api.GetList.RequestQuery }) => ({
    queryKey: [shopID, query] as const,
    queryFn: () => {
      return CornerLogis.proxy<Api.GetList.ResponseBody>({
        method: 'GET',
        path: '/api/v1/inbound/getList',
        params: query,
        shopID,
      });
    },
  }),

  입고_패키지_목록_조회: ({
    shopID,
    inboundId,
  }: {
    shopID: string;
    inboundId: Api.GetInboundPackages.RequestParams['inboundId'];
  }) => ({
    queryKey: [shopID, inboundId] as const,
    queryFn: () => {
      return CornerLogis.proxy<Api.GetInboundPackages.ResponseBody>({
        method: 'GET',
        path: `/api/v1/inbound/${inboundId}/getPackages`,
        // XXX: UI에서 페이징이 따로 없으므로 MAX_PACKAGE_COUNT 처리함. 추후에 필요한 경우, 페이징 처리 필요함.
        params: { page: '1', size: MAX_PACKAGE_COUNT.toString() },
        shopID,
      });
    },
  }),
});
